import { useState } from 'react';
import { Modal, ModalHeader, ModalBody, ModalFooter, Button } from 'reactstrap';

const AnswersModal = ({ open, toggle, answers, loading }) => {
  const [activeTab, setActiveTab] = useState(1);

  const handleTabChange = (tabNumber) => {
    setActiveTab(tabNumber);
  };

  const getQuestionsWithConcepts = (answers) => {
    const questionsWithConcepts = answers?.questionsWithConcepts || [{}, {}];
    
    return questionsWithConcepts.map((question) => {
      const result = { ...question };
      if (question.resultsQuestionText) {
        result.answer = { ...question.resultsQuestionText[0] };
      }
      return result;
    });
  };

  const questionsWithConcepts = getQuestionsWithConcepts(answers);

  const currentQuestion = questionsWithConcepts[activeTab - 1];

  const currentAnswer = currentQuestion.answer;

  const buildTabs = () => {
    return (<>
      {
        questionsWithConcepts.map((question, index) => (
          <button 
              className={`tab-button ${activeTab === (index + 1) ? 'active' : ''}`}
              onClick={() => handleTabChange(index + 1)}
            >
              Pregunta  {index + 1}: {question.answer ? (question.answer?.competence || '-') : '...'}
            </button>
        ))
      }
    </>);
  };
  
  return (
    <Modal
      isOpen={open}
      toggle={toggle}
      size="lg"
      className="gm-answers-modal"
    >
      <ModalHeader toggle={toggle} className="border-0">
        <div className="d-flex align-items-center justify-content-between w-100">
          <div className="tabs-container">{buildTabs()}</div>
        </div>
      </ModalHeader>
      
      <ModalBody>
        <div className="answers-content-container">
          {
            loading && !currentAnswer &&
            <>
              <p>Cargando...</p>
            </>
          }
          {
            !loading && currentAnswer &&
            <>
              <div className="answers-left-column">
                <div className="competency-section">
                  <h3>COMPETENCIA:</h3>
                  <h2>{currentAnswer?.competence || '-'}</h2>
                </div>
                
                <div className="question-section">
                  <h3>PREGUNTA</h3>
                  <p className="question-text">{currentAnswer?.questionSelect || '-'}</p>
                </div>
                
                <div className="selected-alternative-section">
                  <h3>ALTERNATIVA SELECCIONADA</h3>
                  <p className="alternative-text">{currentAnswer?.answerSelect || '-'}</p>
                </div>
                
                <div className="justification-section">
                  <h3>JUSTIFICACIÓN</h3>
                  <p className="justification-text">"{currentAnswer?.answerFundamental || '-'}".</p>
                </div>
              </div>
              
              <div className="answers-right-column">
                <div className="summary-section">
                  <h3>RESUMEN</h3>
                  
                  <div className="summary-item">
                    <p className="summary-level"><strong>Nivel pregunta</strong>: {currentAnswer?.level || '-'}</p>
                  </div>
                  
                  <div className="summary-item">
                    <h3>ANÁLISIS DE CONCEPTOS</h3>
                    <p className="summary-subtext">Conceptos identificados en la respuesta.</p>
                    <p className="summary-concepts">{currentQuestion?.concepts?.join(',') || '-'}</p>
                  </div>
                </div>
              </div>
            </>
          }
        </div>
      </ModalBody>
      
      <ModalFooter className="border-0">
        <Button onClick={toggle} className="gm-close-button">
          Cerrar
        </Button>
      </ModalFooter>
    </Modal>
  );
};

export default AnswersModal; 